module.exports = __webpack_public_path__ + "img/section1_bg_m.1f030e38.png";